import { FilePondFile } from 'filepond';
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import { ButtonContinue } from '../../common/Button/ButtonContinue';
import FileUploader from '../../common/FileUpload/FileUploader';

type UploadNCDDialogProps = {
  showDialog: boolean;
  onCloseModal: () => void;
  onUploadModal: () => void;
  brandName: string;
  file: FilePondFile | undefined;
  onFileChange: (files: FilePondFile[]) => void;
  saveErrorMessage: string;
  token: string;
};

const UploadNCDDialog = ({
  showDialog,
  onCloseModal,
  onUploadModal,
  brandName,
  file,
  onFileChange,
  saveErrorMessage,
  token
}: UploadNCDDialogProps): JSX.Element => {
  const validate = () => {
    return file !== undefined;
  };

  const onClickClose = () => {
    onCloseModal();
  };

  const onClickUpload = () => {
    const isValid = validate();
    if (isValid) {
      onUploadModal();
    }
  };

  const modalClass = 'modal-dialog-' + brandName;

  return (
    <Modal
      role={modalClass}
      className={`insurance-${brandName}`}
      isOpen={showDialog}
      toggle={onClickClose}>
      <ModalHeader toggle={onClickClose}>File Upload</ModalHeader>
      <ModalBody>
        <FileUploader
          allowMultiple={false}
          allowImagePreview={true}
          onFileChange={onFileChange}
          allowPdfs={true}
          token={token}
        />
        <div>{saveErrorMessage}</div>
      </ModalBody>
      <ModalFooter>
        <ButtonContinue
          name='btn-continue'
          text='Save'
          onClick={onClickUpload}
          additionalClassNames='btn-ok'
        />
        <ButtonContinue
          name='btn-close'
          text='Cancel'
          onClick={onClickClose}
          additionalClassNames='btn-cancel'
        />
      </ModalFooter>
    </Modal>
  );
};

export default UploadNCDDialog;
